// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchButton_input__2dKxB","button":"SearchButton_button__2Te87"};